import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function MarketingNav() {
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-background/80 border-b border-border">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-home-logo">
          <div className="h-8 w-8 rounded-lg flex items-center justify-center" style={{ background: "hsl(var(--primary))" }}>
            <Sparkles className="h-4 w-4 text-white" />
          </div>
          <span className="font-display font-bold text-lg tracking-tight">WindowIQX</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm">
          <Link to="/" className="hover:text-primary" data-testid="nav-home">Home</Link>
          <Link to="/pricing" className="hover:text-primary" data-testid="nav-pricing">Pricing</Link>
          <a href="#features" className="hover:text-primary" data-testid="nav-features">Features</a>
          <Link to="/login" className="hover:text-primary" data-testid="nav-login">Log in</Link>
          <Link to="/signup" className="inline-flex items-center rounded-md bg-primary text-primary-foreground px-4 py-2 text-sm font-medium hover:bg-primary/90 active:scale-[0.98] transition" data-testid="nav-cta-signup">
            Start free trial
          </Link>
        </nav>
        <div className="md:hidden flex items-center gap-3 text-sm">
          <Link to="/login" data-testid="nav-login-mobile">Log in</Link>
          <Link to="/signup" className="inline-flex items-center rounded-md bg-primary text-primary-foreground px-3 py-1.5 text-sm font-medium" data-testid="nav-cta-mobile">Start trial</Link>
        </div>
      </div>
    </header>
  );
}
